<template>
  <component :is="tag" class="iconfont" v-html="code" @click="$emit('click')" />
</template>

<script>
import VueTypes from 'vue-types'

export default {
  name: 'com-icon',
  props: {
    tag: VueTypes.string.def('i'),
    code: VueTypes.string
  }
}
</script>
